export default __webpack_public_path__ + "static/media/02.af3dff28.jpg";